module.exports = __webpack_public_path__ + "img/knu2_main1.30f06738.jpg";